import * as amplitude from '@amplitude/analytics-browser';

// Global flag to track Amplitude initialization status
let isAmplitudeInitialized = false;


// Environment variable for API key type
const APIKey_Env = 'REACT_APP_AMPLITUDE_API_KEY_FM_DEV';

/**
 * Initialize Amplitude with API key and optional tracking configurations.
 * @param {string} APIKey_type - The environment variable to retrieve the API key.
 */
export const initAmplitude = async (APIKey_type = APIKey_Env) => {
  if (isAmplitudeInitialized) {
    console.log("Amplitude is already initialized.");
    return;  // Skip initialization if Amplitude is already initialized
  }

  const apiKey = process.env[APIKey_type];

  if (!apiKey) {
    console.error("Amplitude API key is missing.");
    return;
  }

  try {
    // Initialize Amplitude SDK with the provided API key
    await amplitude.init(apiKey,  undefined, {
      autocapture: {
          attribution: false,
          pageViews: false,
          fileDownload: false,
          formInteractions: false,
          elementInteractions: false// Disables automatic form submission tracking
      },
      defaultTracking: false,
      cookieOptions: {
          secure: document.location.protocol === "https:",
      }
  }).promise;

    console.log("Amplitude initialized successfully.");
    isAmplitudeInitialized = true;  // Set the flag to true after successful initialization
  } catch (error) {
    console.error("Error initializing Amplitude:", error);
  }
};

/**
 * Set user identity details in Amplitude as user properties.
 * @param {Object} eventProperties - The user details.
 */
export const identityCall = (eventProperties) => {
  const { userID, userRole, client, version } = eventProperties;
  const id = new amplitude.Identify()
    .set("userId", userID)
    .set("role", userRole)
    .set("client", client)
    .set("version", version);

  amplitude.identify(id);
};

/**
 * Log an event to Amplitude with the specified event type and properties.
 * @param {string} eventType - The type of the event.
 * @param {Object} eventProperties - The properties of the event.
 */
export const setAmplitudeEvent = async (eventType, eventProperties = {}) => {
  await initAmplitude(APIKey_Env);  // Ensure Amplitude is initialized before logging events
  amplitude.logEvent(eventType, eventProperties);
};

/**
 * Log an event to Amplitude with just the event type (no properties).
 * @param {string} eventType - The type of the event.
 */
export const sendSingleAmplitudeEvent = async (eventType) => {
  await initAmplitude(APIKey_Env);  // Ensure Amplitude is initialized
  amplitude.logEvent(eventType);
};

/**
 * Set the device ID for the user in Amplitude.
 * @param {string} installationToken - The installation token to be set as device ID.
 */
export const setAmplitudeUserDevice = (installationToken) => {
  amplitude.setDeviceId(installationToken);
};

/**
 * Set the user ID in Amplitude.
 * @param {string} userId - The user ID to be set.
 */
export const setAmplitudeUserId = (userId) => {
  amplitude.setUserId(userId);
};

/**
 * Set multiple user properties in Amplitude.
 * @param {Object} properties - The user properties to be set.
 */
export const setAmplitudeUserProperties = (properties) => {
  const identify = new amplitude.Identify();

  // Loop through properties and set them
  Object.entries(properties).forEach(([key, value]) => {
    identify.set(key, value);
  });

  amplitude.identify(identify);
};
